import api from './api';

const doctorService = {
  getAllDoctors: (params) => api.get('/doctors/admin/all', { params }),
  getDoctorById: (id) => api.get(`/doctors/${id}`),
  createDoctor: (data) => {
    const formData = new FormData();
    formData.append('folder', 'doctors');
    Object.keys(data).forEach((key) => {
      if (key === 'profileImage' && data[key] instanceof File) {
        formData.append('profileImage', data[key]);
      } else if (data[key] !== undefined && data[key] !== null && data[key] !== '') {
        if (Array.isArray(data[key])) {
          formData.append(key, JSON.stringify(data[key]));
        } else {
          formData.append(key, data[key]);
        }
      }
    });
    return api.post('/doctors', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  updateDoctor: (id, data) => {
    const formData = new FormData();
    formData.append('folder', 'doctors');
    Object.keys(data).forEach((key) => {
      if (key === 'profileImage' && data[key] instanceof File) {
        formData.append('profileImage', data[key]);
      } else if (data[key] !== undefined && data[key] !== null && data[key] !== '') {
        if (Array.isArray(data[key])) {
          formData.append(key, JSON.stringify(data[key]));
        } else {
          formData.append(key, data[key]);
        }
      }
    });
    return api.put(`/doctors/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  deleteDoctor: (id) => api.delete(`/doctors/${id}`),
  toggleStatus: (id) => api.patch(`/doctors/${id}/toggle-status`),
  verifyDoctor: (id) => api.patch(`/doctors/${id}/verify`),
};

export default doctorService;
